import { useState, useCallback, JSX } from 'react';
import { Box } from '@mui/material';
import { AxiosProgressEvent } from 'axios';

import { CircularProgress } from '@components';

type ProgressFunction = (progressEvent: AxiosProgressEvent) => void;

export const useLoadingDialog = (): [JSX.Element | null, ProgressFunction] => {
  const [progress, setProgress] = useState(0);
  const [hasTotal, setHasTotal] = useState(true);

  const handleProgress = useCallback((progressEvent: AxiosProgressEvent) => {
    if (progressEvent.total && progressEvent.total > 0) {
      setHasTotal(true);
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      setProgress(percentCompleted);
    } else {
      setHasTotal(false); // fallback to indeterminate
      setProgress(-1); // indicate unknown progress
    }
  }, []);

  const dialog =
    progress > 0 ? (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        }}
      >
        {hasTotal && progress >= 0 ? (
          <CircularProgress value={progress} />
        ) : (
          <CircularProgress />
        )}
      </Box>
    ) : null;

  return [dialog, handleProgress];
};
